<template>
  <div class="searchandselect_main">
    <el-input
      :placeholder="isGaonS?isEnglish?'Start searching now…':'请输入ID或关键字查询':'请输入ID或关键字查询'"
      v-model="searchtext"
      class="input-with-select"
    >
      <el-select v-if="!ishowvideo" v-model="select" slot="append" placeholder="请选择">
        <el-option :label="isGaonS?isEnglish?'All Images':'全部素材':'全部素材'" value="0"></el-option>
        <el-option v-if="!ishowvideo" :label="isGaonS?isEnglish?'Images':'图片':'图片'" value="1"></el-option>
        <el-option v-if="!ishowvideo" :label="isGaonS?isEnglish?'Video':'视频':'视频'" value="3"></el-option>
        <!-- <el-option label="音频" value="3"></el-option>
        <el-option label="文件" value="4"></el-option>-->
      </el-select>
      <el-button
        slot="append"
        type="danger"
        @click="toSearch"
      >{{isGaonS?isEnglish?'Search':'搜索':'搜索'}}</el-button>
    </el-input>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      select: "0",
      searchtext: "",
      keyI: 0
    };
  },
  computed: {
    ...mapGetters(["isGaonS", "isEnglish"]),
    ishowvideo() {
      return window.location.href.includes("39.97.23.148");
    }
  },
  watch: {
    keyI(val) {
      if (val == 13) {
        this.toSearch();
      }
    }
  },
  created() {
    this.keyevent();
  },
  mounted() {},
  methods: {
    keyevent() {
      var that = this;
      document.onkeydown = function(e) {
        //按下键盘
        that.keyI = e.keyCode;
      };
    },
    toSearch() {
      this.$router.push({
        path: "/search",
        query: {
          type: 0,
          asset_type: this.select,
          text: encodeURI(this.searchtext)
        }
      });
    }
  }
};
</script>
<style lang="less">
.searchandselect_main {
  border: 1px solid rgba(0, 0, 0, 0.1);
  .el-input-group__append {
    // opacity: 0.65;
  }
  .el-input__inner {
    height: 45px;
    // background-color: rgba(255, 255, 255, 0.85);
    background-color: rgba(255, 255, 255, 1);
    // border-top-left-radius: 40px;
    // border-bottom-left-radius: 40px;
    border: 1px solid transparent !important;
  }
  .input-with-select {
    // border-radius: 40px;
    overflow: hidden;
    font-size: 16px;
    .el-input-group__append {
      width: 170px;
      color: #333;
      border: 1px solid transparent !important;
      .el-select {
        width: 120px;
      }
      .el-button {
        background-color: red;
        margin-left: 21px;
        // height: 100%;
        // height: 60px;
        color: white;
        // position: absolute;
        width: 100px;
        // background-color: red;
        // margin-left: 20px;
        // height: 30px;
        // color: white;
        // // vertical-align: middle;
        // position: absolute;
        // top: 23px;
        span {
          // position: relative;
          // top: -5px;
        }
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/searchAndselect.vue